module.exports = __webpack_public_path__ + "img/NvpMGd6hDcnbPwyZUtwCeP@2x.80b23180.png";